// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterPanel__Jw0jy {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  padding: 15px 25px;
}

.filtersBlock__Tboe_ {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.selectField__qhnHR {
  width: 200px;
}
@media (max-width: 1420px) {
  .selectField__qhnHR {
    width: 150px;
  }
}

.fieldLabel__gS5Nw {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: block;
  margin-bottom: 8px;
}

.datepickerRange__NrdZk {
  min-width: 190px;
}

.averageTime__DC2Ft {
  min-width: 360px;
}
@media (max-width: 1340px) {
  .averageTime__DC2Ft {
    min-width: 300px;
  }
}

.extraFilters__kCu7Y {
  display: flex;
  align-items: center;
  column-gap: 10px;
}
@media (max-width: 1440px) {
  .extraFilters__kCu7Y {
    display: none;
  }
}

.resetWrapper__YjuOO {
  align-self: flex-end;
}

.slideRangeFieldWrapper__ubJBX .input-field {
  max-width: 90px !important;
}

.iconsBlock__eqaIG {
  display: flex;
  align-items: center;
  align-self: flex-end;
  border-radius: 2px;
  background: var(--segments-chips-toggle-surface-default);
}

.iconWrapper__DJTAj {
  padding: 8px;
}
.iconWrapper__DJTAj:hover {
  cursor: pointer;
}

.statisticIcon__XuEX4 {
  fill: var(--segments-chips-toggle-text-default);
}

.searchIcon__r4dgo path {
  stroke: var(--segments-chips-toggle-text-default);
}

.activeIcon__AKe_P {
  border-radius: 2px;
  background: var(--segments-chips-toggle-surface-active);
}
.activeIcon__AKe_P .statisticIcon__XuEX4 path {
  fill: var(--buttons-surface);
}
.activeIcon__AKe_P .searchIcon__r4dgo path {
  stroke: var(--buttons-surface);
}

.extraPanel__XIKHZ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
}

.archiveSearch___6LGN {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  padding: 0 25px;
  height: 45px;
}

.startAdornment__mAHiU {
  font-size: 12px;
  line-height: 20px;
  color: var(--title-inputs-sections-title);
  padding-right: 5px;
}

.additionalFiltersMenu__imLvQ {
  margin-top: 19px;
}

.extraFiltersIconContainer__mxyT4 {
  width: 35px;
  height: 35px;
  border-radius: 2px;
  background: var(--segments-chips-toggle-surface-default);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.extraFiltersIconContainer__mxyT4 .filterIcon__xWHv8 circle {
  fill: var(--segments-chips-toggle-text-default);
}

.activeExtraFiltersIconContainer__IeG7W {
  background: var(--segments-chips-toggle-surface-active);
}
.activeExtraFiltersIconContainer__IeG7W .filterIcon__xWHv8 circle {
  fill: var(--buttons-surface);
}

.activeExtraFiltersIconDot__VOEgL {
  display: block;
}
.activeExtraFiltersIconDot__VOEgL:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--buttons-surface);
}

@media (max-width: 1440px) {
  .activeSmallWidthExtraFiltersIconDot__UOsPX {
    display: block;
  }
  .activeSmallWidthExtraFiltersIconDot__UOsPX:after {
    content: "";
    position: absolute;
    top: -2px;
    right: -2px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--buttons-surface);
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/Archive/components/ArchiveFilter/style.module.scss"],"names":[],"mappings":"AAqFA;EAVE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qDAAA;EACA,2FACE;EAMF,kBAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA/EF;;AAkFA;EACE,YAAA;AA/EF;AAiFE;EAHF;IAII,YAAA;EA9EF;AACF;;AAiFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;AA9EF;;AAiFA;EACE,gBAAA;AA9EF;;AAiFA;EACE,gBAAA;AA9EF;AAgFE;EAHF;IAII,gBAAA;EA7EF;AACF;;AAgFA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA7EF;AA+EE;EALF;IAMI,aAAA;EA5EF;AACF;;AA+EA;EACE,oBAAA;AA5EF;;AAiFI;EACE,0BAAA;AA9EN;;AAmFA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,wDAAA;AAhFF;;AAmFA;EACE,YAAA;AAhFF;AAkFE;EACE,eAAA;AAhFJ;;AAoFA;EACE,+CAAA;AAjFF;;AAoFA;EACE,iDAAA;AAjFF;;AAoFA;EACE,kBAAA;EACA,uDAAA;AAjFF;AAmFE;EACE,4BAAA;AAjFJ;AAoFE;EACE,8BAAA;AAlFJ;;AAsFA;EA/GE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qDAAA;EACA,2FACE;AA4BJ;;AAiFA;EAnHE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qDAAA;EACA,2FACE;EA+GF,eAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAzEF;AA4EI;EACE,+CAAA;AA1EN;;AA+EA;EACE,uDAAA;AA5EF;AA+EI;EACE,4BAAA;AA7EN;;AAiGA;EAdE,cAAA;AA/EF;AAiFE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;AA/EJ;;AAwFE;EADF;IAlBE,cAAA;EAhEA;EAkEA;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;IACA,kCAAA;EAhEF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@mixin archiveFilterPanel {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow:\n    0px 0px 1px 0px rgba(12, 26, 75, 0.24),\n    0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n}\n\n.filterPanel {\n  @include archiveFilterPanel;\n  padding: 15px 25px;\n}\n\n.filtersBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.selectField {\n  width: 200px;\n\n  @media (max-width: 1420px) {\n    width: 150px;\n  }\n}\n\n.fieldLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: block;\n  margin-bottom: 8px;\n}\n\n.datepickerRange {\n  min-width: 190px;\n}\n\n.averageTime {\n  min-width: 360px;\n\n  @media (max-width: 1340px) {\n    min-width: 300px;\n  }\n}\n\n.extraFilters {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n\n  @media (max-width: 1440px) {\n    display: none;\n  }\n}\n\n.resetWrapper {\n  align-self: flex-end;\n}\n\n.slideRangeFieldWrapper {\n  :global {\n    .input-field {\n      max-width: 90px !important;\n    }\n  }\n}\n\n.iconsBlock {\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  border-radius: 2px;\n  background: var(--segments-chips-toggle-surface-default);\n}\n\n.iconWrapper {\n  padding: 8px;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.statisticIcon {\n  fill: var(--segments-chips-toggle-text-default);\n}\n\n.searchIcon path {\n  stroke: var(--segments-chips-toggle-text-default);\n}\n\n.activeIcon {\n  border-radius: 2px;\n  background: var(--segments-chips-toggle-surface-active);\n\n  .statisticIcon path {\n    fill: var(--buttons-surface);\n  }\n\n  .searchIcon path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.extraPanel {\n  @include archiveFilterPanel;\n}\n\n.archiveSearch {\n  @include archiveFilterPanel;\n  padding: 0 25px;\n  height: 45px;\n}\n\n.startAdornment {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--title-inputs-sections-title);\n  padding-right: 5px;\n}\n\n.additionalFiltersMenu {\n  margin-top: 19px;\n}\n\n.extraFiltersIconContainer {\n  width: 35px;\n  height: 35px;\n  border-radius: 2px;\n  background: var(--segments-chips-toggle-surface-default);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n\n  .filterIcon {\n    circle {\n      fill: var(--segments-chips-toggle-text-default);\n    }\n  }\n}\n\n.activeExtraFiltersIconContainer {\n  background: var(--segments-chips-toggle-surface-active);\n\n  .filterIcon {\n    circle {\n      fill: var(--buttons-surface);\n    }\n  }\n}\n\n@mixin extraFiltersIconDot {\n  display: block;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--buttons-surface);\n  }\n}\n\n.activeExtraFiltersIconDot {\n  @include extraFiltersIconDot;\n}\n\n.activeSmallWidthExtraFiltersIconDot {\n  @media (max-width: 1440px) {\n    @include extraFiltersIconDot;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `filterPanel__Jw0jy`,
	"filtersBlock": `filtersBlock__Tboe_`,
	"selectField": `selectField__qhnHR`,
	"fieldLabel": `fieldLabel__gS5Nw`,
	"datepickerRange": `datepickerRange__NrdZk`,
	"averageTime": `averageTime__DC2Ft`,
	"extraFilters": `extraFilters__kCu7Y`,
	"resetWrapper": `resetWrapper__YjuOO`,
	"slideRangeFieldWrapper": `slideRangeFieldWrapper__ubJBX`,
	"iconsBlock": `iconsBlock__eqaIG`,
	"iconWrapper": `iconWrapper__DJTAj`,
	"statisticIcon": `statisticIcon__XuEX4`,
	"searchIcon": `searchIcon__r4dgo`,
	"activeIcon": `activeIcon__AKe_P`,
	"extraPanel": `extraPanel__XIKHZ`,
	"archiveSearch": `archiveSearch___6LGN`,
	"startAdornment": `startAdornment__mAHiU`,
	"additionalFiltersMenu": `additionalFiltersMenu__imLvQ`,
	"extraFiltersIconContainer": `extraFiltersIconContainer__mxyT4`,
	"filterIcon": `filterIcon__xWHv8`,
	"activeExtraFiltersIconContainer": `activeExtraFiltersIconContainer__IeG7W`,
	"activeExtraFiltersIconDot": `activeExtraFiltersIconDot__VOEgL`,
	"activeSmallWidthExtraFiltersIconDot": `activeSmallWidthExtraFiltersIconDot__UOsPX`
};
module.exports = ___CSS_LOADER_EXPORT___;
